module.exports = __webpack_public_path__ + "static/media/2020s-ePoster-icon.dc77f6aa.png";